/**
 * Created by robincoburn on 30/09/15.
 */
angular.module('qkr').directive('couponRedemption', ($uibModal, gettextCatalog) => ({

        restrict: 'E',
        scope: {
            merchantInfo: '=',
            locations: '=',
            model: '=',
            // UsageLimit: "=",
            // UsageDiscriminator: "=",
            errors: '=',
            config: '=',
            couponForm: '='
        },
        template: require('../../coupons/templates/couponRedemption.html'),
        link(scope) {
            scope.isEdit = scope.config.isEdit;
            scope.canEdit = scope.config.canEdit;
            scope.currency = scope.config.currency;
            scope.deptBasedCoupon = scope.config.deptBasedCoupon;
            scope.supplyCoupon = parent.merchantService ?
                parent.merchantService.behaviour(scope.merchantInfo, 'couponPage.supplyCoupon') : null;
            scope.readOnly = scope.config.readOnly;
            scope.redemptionRulesChecks = {
                hasMinCartTotal: (scope.model.minCartTotal !== null && scope.model.minCartTotal !== undefined),
                hasMaxDiscount: (scope.model.maxDiscount !== null && scope.model.maxDiscount !== undefined)
            };
            scope.usageOptions = [
                {type: 'DAILY', description: gettextCatalog.getString('Daily')},
                {type: 'WEEKLY', description: gettextCatalog.getString('Weekly')},
                {type: 'MONTHLY', description: gettextCatalog.getString('Monthly')},
                {type: 'EVER', description: gettextCatalog.getString('Ever')}];

            scope.singleMultipleChoice = [
                {bool: true, label: gettextCatalog.getString('Single')}
            ];

            scope.holder = {};
            scope.holder.minDate = new Date();

            scope.showLocations = true;
            if (scope.locations.length <= 1) {
                scope.showLocations = false;
            } else if ((scope.config.couponOutletLevel || scope.config.outletLevel)
                && (!scope.config.deptBasedCoupon && !scope.supplyCoupon)) {
                scope.showLocations = false;
            }

            scope.showLocationModal = function() {
                const modalInstance = $uibModal.open({
                    template: require('../../coupons/templates/couponLocations.html'),
                    controller: 'couponLocationController',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        merchantInfo() {
                            return scope.merchantInfo;
                        },
                        locations() {
                            return scope.locations;
                        },
                        deptBasedCoupon() {
                            return scope.deptBasedCoupon;
                        }
                    }
                });

                modalInstance.result.then((locations) => {
                    if (locations.length > 0) {
                        scope.model.applicableLocations = locations;
                    } else {
                        scope.model.applicableLocations = [];
                    }
                });
            };

            /*
            * There's a good reason for this angular.element.scope for minCartTotal and maxDiscount -
            * both get lost in the directive's, accordion & accordion-group's scope
            * we need to manually set the scope on this directive so that the createCouponController can access
            * the user's entered values, and we also need to reset the
            * scope on the element when it needs to be cleared so that the user can see that what
            * they entered was cleared
            * */
            scope.setCouponExtras = function(changed) {
                if (changed === 'minCartTotal') {
                    if (!scope.redemptionRulesChecks.hasMinCartTotal) {
                        scope.model.minCartTotal = undefined;
                        angular.element('#minCartTotal').scope().minCartTotal = undefined;
                    }
                } else if (changed === 'maxDiscount') {
                    if (!scope.redemptionRulesChecks.hasMaxDiscount) {
                        scope.model.maxDiscount = undefined;
                        angular.element('#maxDiscount').scope().maxDiscount = undefined;
                    }
                }
            };
            

            scope.filterSingleMultiUsage = function(usage) {
                // First Time Usage and Purchase Reward coupons can only be used once
                if (usage.excludedAcquireTypes) {
                    return usage.excludedAcquireTypes.indexOf(scope.aquireMechanism) === -1;
                } else {
                    return true;
                }
            };

            if (scope.isEdit) {
                scope.unlimitedUsages = (scope.usageLimit === null || scope.usageLimit === undefined);
            } else {
                scope.unlimitedUsages = true;
            }
        }
    }));



// WEBPACK FOOTER //
// ./src/coupons/directives/couponRedemption.js